export const PRIMARY = "#0b3d87";
export const ACCENT = "#e00036";
export const PAGE_BG = "#f5f5f5";
export const LOGO_MAX_BYTES = 1024 * 1024;
/** Form label for logo upload (aligned with other field labels). */
export const LOGO_FIELD_LABEL = "Logo aziendale";

/** Fields sent to backend or validated for save (excludes address UI-only and transient SFTP password). */
export const profilePersistedFormFields = [
  { label: "Nome commerciale", name: "nomeCommerciale" },
  { label: "Ragione sociale", name: "ragioneSociale" },
  { label: "Partita IVA", name: "partitaIVA" },
  { label: "Codice fiscale", name: "codiceFiscale" },
  {
    label: "Email",
    name: "indirizzoEmail",
    labelTooltip: "Attenzione! Questo è l'indirizzo usato per accedere a questo portale.",
  },
  { label: "Indirizzo PEC", name: "indirizzoPec", labelTooltip: "Almeno uno tra PEC e SDI deve essere compilato." },
  { label: "Codice SDI", name: "codiceSDI", labelTooltip: "Almeno uno tra PEC e SDI deve essere compilato." },
  { label: "Sito Web", name: "sitowebAziendale" },
  { label: "Telefono aziendale", name: "numeroTelefono" },
  { label: "Nome", name: "nomeReferente" },
  { label: "Cognome", name: "cognomeReferente" },
  { label: "Email", name: "emailReferente" },
  { label: "Telefono", name: "telefonoReferente" },
  {
    label: "SFTP server URL",
    name: "urlSftp",
    labelTooltip: "Attenzione! Modificando questo potrebbe non essere più possibile accedere al tuo catalogo.",
  },
  { label: "Utente", name: "utenteSftp", labelTooltip: "Da compilare solo nel caso in cui il server SFTP richieda un utente." },
  { label: "Password", name: "passwordSftp", labelTooltip: "Da compilare solo nel caso in cui il server SFTP richieda una password." },
  { label: "Email pubblica", name: "emailPubblica" },
];

// Fields used for dirty tracking; address field UI lives in SedeAziendale.
export const profileAddressOnlyFields = [
  { label: "Via", name: "indirizzoVia" },
  { label: "Civico", name: "indirizzoCivico" },
  { label: "CAP", name: "indirizzoCap" },
  { label: "Città", name: "indirizzoCitta" },
  { label: "Provincia", name: "indirizzoProvincia" },
  { label: "Regione", name: "indirizzoRegione" },
  { label: "Stato", name: "indirizzoStato" },
];

export const profileFormFieldsForDirty = [...profilePersistedFormFields, ...profileAddressOnlyFields];

export const formFields = [...profileFormFieldsForDirty];

export const fieldLabel = (name) => formFields.find((f) => f.name === name)?.label ?? name;

export const fieldLabelTooltip = (name) => formFields.find((f) => f.name === name)?.labelTooltip;

export const sortPaymentMethodIds = (ids) => [...ids].sort((a, b) => a - b);
